<template >
  <div>
    <div v-if="!homePage" class="container">

      <div style="margin: 1%">
        <span class="title">{{ name }}</span>
      </div>
      <div class="content">
        <div style="margin-left: 1%">
          <q-btn round class="previous-button" size="lg" icon="arrow_back_ios_new">
          </q-btn>
        </div>

        <div class="scene">
          <div class="carousel">
            <div class="carousel__cell" v-for="(resource, index) in resources" :key="index">
              <img v-bind:src="resourceUrls[index]" />
            </div>
          </div>
        </div>
        <div style="margin-right: 1%">
          <q-btn round class="next-button" size="lg" icon="arrow_forward_ios_new"></q-btn>
        </div>
      </div>
      <div class="footer">

        <div class="marquee-rtl">
          <div>Université de Corse</div>
        </div>
        <div class="credits">
          <span>Mentions Legales</span>
          <br />
        </div>
        <div>
          <span>Fattu in Corsica</span>
        </div>
      </div>
      <svg class='wave' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#E8EBEB" fill-opacity="1"
          d="M0,160L60,170.7C120,181,240,203,360,208C480,213,600,203,720,176C840,149,960,107,1080,101.3C1200,96,1320,128,1380,144L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
        </path>
      </svg>
    </div>
    <div class="home-container" v-else>
      <component :is="selectedTemplate" :homeImage="homeImage" :exhibitIdProps="exhibitId" @exit="exitHomePage"></component>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";

export default {
  components: {
    Modele_2,
    Modele_3,
    Modele_1,
    Modele_4,
    Modele_5,
    Modele_6,
    Modele_7
  },
  props: [
    'homePageProps',
    'exhibitId'
  ],
  data() {
    return {
      id: this.$route.params.id ?? this.exhibitId,
      resources: [],
      name: "",
      userName: "",
      headImage: [],
      cartel: false,
      description: "",
      homePage: this.homePageProps ?? true,
      homeImage: {},
      resourceUrls: [],
      // composant dynamique pour la page d'accueil
      selectedTemplate: null
    };
  },
  methods: {
    getHeadImage(index) {
      let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${this.resources[index].name}`;
      console.log(url);
      return url;
    },
    async fetchResources() {
      if (this.resources.length === 0) {
        // Attendre que les ressources soient chargées si nécessaire
        await this.getResources();
      }

      // Utiliser Promise.all pour attendre que toutes les requêtes soient terminées
      const urls = this.resources.map(resource => `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`);
      try {
        const responses = await Promise.all(urls.map(url => axios.get(url)));
        this.resourceUrls = responses.map(response => response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des URLs des ressources", error);
      }
    },
    async getUserName() {
      let url = `${process.env.VUE_APP_BASEURL}/user/${this.id}`;
      let response = await axios.get(url);
      this.userName = response.data.name;
    },
    async getExhibitName() {
      let url = `${process.env.VUE_APP_BASEURL}/exhibit/${this.id}`;
      let response = await axios.get(url);
      this.name = response.data.exhibit_name;
    },
    showCartel(index) {
      this.cartel = true;
      this.description = this.resources[index].description;
    },
    async getHomeImage() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${this.$route.params.id || this.exhibitId}`;
        let response = await axios.get(url);
        this.homeImage = response.data[0];
      } catch (error) {
        console.log(error)
      }
    },
    async getModel() {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${this.$route.params.id ?? this.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          // clé de modèle renvoyée (ex: "template_4")
          const raw = (response.data[0].model || '').replace(/è/g, 'e').replace(/\s+/g, '_');
          const map = {
            template_1: 'Modele_1',
            template_2: 'Modele_2',
            template_3: 'Modele_3',
            template_4: 'Modele_4',
            template_5: 'Modele_5',
            template_6: 'Modele_6',
            template_7: 'Modele_7'
          };
          const compName = map[raw] || 'Modele_1';
          // Résoudre vers l'objet composant importé
          this.selectedTemplate = this.$options.components[compName];
        } else {
          // fallback par défaut
          this.selectedTemplate = this.$options.components['Modele_1'];
        }
      } catch (error) {
        console.log(error);
        // fallback en cas d'erreur
        this.selectedTemplate = this.$options.components['Modele_1'];
      }
    },
    exitHomePage() {
      this.homePage = false;
      setTimeout(() => {
        this.initCarousel();

      }, 2000)

    },
    async getResources() {
      let exhibitId = this.$route.params.id ?? this.exhibitId;

      try {
        // Obtenir les ressources de l'exposition
        let resourcesUrl = `${process.env.VUE_APP_BASEURL}/resources`;
        let response = await axios.post(resourcesUrl, { exhibitId });
        let allResources = response.data;

        // Obtenir les resource_id de gallery_resource
        let galleryUrl = `${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId}`;
        let galleryResponse = await axios.get(galleryUrl);
        let galleryResourceIds = galleryResponse.data.map(res => res.resource_id);

        // Filtrer les ressources pour ne garder que celles présentes dans gallery_resource
        this.resources = allResources.filter(resource =>
          galleryResourceIds.includes(resource.id)
        );
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    }
    ,
    initCarousel() {
      var carousel = document.querySelector(".carousel");
      var cells = carousel.querySelectorAll(".carousel__cell");
      var cellCount;
      var selectedIndex = 0;
      var cellWidth = 500;
      var cellHeight = 200;
      var isHorizontal = true;
      var rotateFn = isHorizontal ? "rotateY" : "rotateX";
      var radius, theta;
      changeCarousel()
      function rotateCarousel() {
        var angle = theta * selectedIndex * -1;
        carousel.style.transform =
          "translateZ(" + -radius + "px) " + rotateFn + "(" + angle + "deg)";
      }

      var prevButton = document.querySelector(".previous-button");
      prevButton.addEventListener("click", function () {
        selectedIndex--;
        rotateCarousel();
      });

      var nextButton = document.querySelector(".next-button");
      nextButton.addEventListener("click", function () {
        selectedIndex++;
        rotateCarousel();
      });


      function changeCarousel() {
        cellCount = document.querySelectorAll('.carousel__cell').length;
        theta = 360 / cellCount;
        var cellSize = isHorizontal ? cellWidth : cellHeight;
        radius = Math.round(cellSize / 2 / Math.tan(Math.PI / cellCount));
        for (var i = 0; i < cells.length; i++) {
          var cell = cells[i];
          if (i < cellCount) {
            // visible cell
            cell.style.opacity = 1;
            var cellAngle = theta * i;
            cell.style.transform =
              rotateFn +
              "(" +
              cellAngle +
              "deg) translateZ(" +
              (radius + 50) +
              "px)";
          } else {
            // hidden cell
            cell.style.opacity = 0;
            cell.style.transform = "none";
          }
        }

        rotateCarousel();
      }
    },
  },

  created() {
    this.getHomeImage();
    this.getResources();
    this.fetchResources();
    this.getExhibitName();
    this.getUserName();
    this.getModel();
  },
};
</script>

<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Dongle&display=swap");

* {
  box-sizing: border-box;
}

body {
  text-align: center;
  background-color: #f1f2f3;
  font-family: "Dongle", sans-serif;
}

.container {
  background-color: #f1f2f3;
  height: 100vh;
  width: 100wh;
  margin-top: -12px;
}

.scene {
  margin: 40px 0;
  position: relative;
  width: 510px;
  height: 240px;
  margin: 80px auto;
  perspective: 1000px;
}

.carousel {
  width: 100%;
  height: 100%;
  position: absolute;
  transform: translateZ(-288px);
  transform-style: preserve-3d;
  transition: transform 1s;
}

.carousel__cell {
  position: absolute;
  width: 500px;
  height: 200px;
  left: 10px;
  top: 10px;
  line-height: 116px;
  font-size: 80px;
  font-weight: bold;
  color: white;
  text-align: center;
  transition: transform 1s, opacity 1s;
}

.carousel__cell:nth-child(9n + 1) {
  background: hsla(0, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 2) {
  background: hsla(40, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 3) {
  background: hsla(80, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 4) {
  background: hsla(120, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 5) {
  background: hsla(160, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 6) {
  background: hsla(200, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 7) {
  background: hsla(240, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 8) {
  background: hsla(280, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(9n + 0) {
  background: hsla(320, 100%, 50%, 0.8);
}

.carousel__cell:nth-child(1) {
  transform: rotateY(0deg) translateZ(288px);
}

.carousel__cell:nth-child(2) {
  transform: rotateY(40deg) translateZ(288px);
}

.carousel__cell:nth-child(3) {
  transform: rotateY(80deg) translateZ(288px);
}

.carousel__cell:nth-child(4) {
  transform: rotateY(120deg) translateZ(288px);
}

.carousel__cell:nth-child(5) {
  transform: rotateY(160deg) translateZ(288px);
}

.carousel__cell:nth-child(6) {
  transform: rotateY(200deg) translateZ(288px);
}

.carousel__cell:nth-child(7) {
  transform: rotateY(240deg) translateZ(288px);
}

.carousel__cell:nth-child(8) {
  transform: rotateY(280deg) translateZ(288px);
}

.carousel__cell:nth-child(9) {
  transform: rotateY(320deg) translateZ(288px);
}

img {
  object-fit: cover;
  width: 500px;
  height: 250px;
  border-radius: 10px;
}

.carousel-options {
  text-align: center;
  position: relative;
  z-index: 2;
  background: hsla(0, 0%, 100%, 0.8);
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.footer {
  display: flex;
  position: absolute;
  bottom: 10px;
  width: 30%;
  justify-content: space-evenly;
  z-index: 99;
  color: black;
  font-size: 1.2rem;
  font-family: "Dongle", sans-serif;

}

.title {
  font-size: 4rem;
  margin: 5%;
  font-family: "Dongle", sans-serif;
}

.wave {
  position: absolute;
  bottom: 0;
}</style>